import { ReferenceComboField, ReferenceMultiField } from './fields';

const CREDENTIAL_HINT = 'What you choose here is what your company asks for or welcomes. EPN does not say the law or a regulator requires it.';

/**
 * Step 4: education and experience (chosen from the reference lists, your own value allowed after a confirmation), skills, certifications, licenses and
 * languages (several values each), travel, work arrangement, physical requirements and working conditions. The employment guidance that used to sit
 * here (pay type, FLSA, overtime ...) moved to Step 5, Compensation, where the rest of the pay-related guidance is.
 */
export function QualificationsStep() {
  return (
    <div className="jr-step jr-grid" data-testid="qualifications-step">
      <ReferenceComboField k="minimumEducation" />
      <ReferenceComboField k="preferredEducation" />
      <ReferenceComboField k="minimumExperience" />
      <ReferenceComboField k="preferredExperience" />
      <ReferenceMultiField k="technicalSkills" noun="skill" isWide />
      <ReferenceMultiField k="professionalSkills" noun="skill" isWide />
      <ReferenceMultiField k="preferredSkills" noun="skill" isWide />
      <ReferenceMultiField k="certifications" noun="certification" isWide hint={CREDENTIAL_HINT} />
      <ReferenceMultiField k="licenses" noun="license" isWide hint={CREDENTIAL_HINT} />
      <ReferenceMultiField k="languages" noun="language" isWide />
      <ReferenceComboField k="travel" />
      <ReferenceComboField k="workArrangement" />
      <ReferenceMultiField k="physicalRequirements" noun="requirement" isWide />
      <ReferenceMultiField k="workingConditions" noun="condition" isWide />
    </div>
  );
}
